export const HEADER_NAV_VALUES = ['profile', 'benefits', 'details', 'review'];
